import { Theme } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme): Record<string, CSSProperties> => ({
  questionCategoryHeading: {
    marginBottom: "0.75rem",
    textDecoration: "underline",
  },
  columnHeadingsWrapper: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "2rem",
  },
  questionRow: {
    display: "flex",
    alignItems: "center",
    backgroundColor: `rgba(${hexToRGB(theme.palette.secondary.main)}, 0.075)`,
  },
  question: {
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    gridGap: "0.5rem",
    width: "100%",
  },
  studentQuestion: {
    backgroundColor: `rgba(${hexToRGB(theme.palette.primary.main)}, 0.15)`,
  },
  coachQuestion: {
    backgroundColor: `rgba(${hexToRGB(theme.palette.error.main)}, 0.15)`,
  },
  parentQuestion: {
    backgroundColor: `rgba(${hexToRGB(theme.palette.secondary.main)}, 0.1)`,
  },
  scaleProperties: {
    backgroundColor: "#eff1f4",
  },
  scalePropertyDiv: {
    width: "50%",
  },
  textArea: {
    resize: "vertical",
    width: "100%",
  },
});



// WEBPACK FOOTER //
// ./src/features/admin/pages/template-editor/styles.ts